module.exports = __webpack_public_path__ + "static/media/step5.97b0898d.png";